import React, { useEffect, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import * as Mui from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import { useRouter } from "@shoothill/core";
import UserViewModel from "Globals/ViewModels/UserViewModel";
import styled from "styled-components";
import { theme } from "Globals/Styles/AppTheme";

export const Container = styled(Mui.Box)`
    .MuiTableCell-root {
        font-size: 0.8rem;
    }
    .MuiTableSortLabel-root {
        :hover {
            color: lightgray;
        }
    }
    .MuiTableRow-root {
        cursor: pointer;
        :hover {
            background-color: lightgray;
        }
    }
    td {
        font-size: 14px !important;
    }
`;

const StyledRoundedButton = styled(Mui.Button)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    border-radius: 15px;
    padding: 9px 26px;
    margin-left: 10px;
    background-color: ${theme.palette.hightownBlue.light};
    color: ${theme.palette.common.white};
    :hover {
        background-color: ${theme.palette.hightownBlue.light};
    }
`;

export const UserListContainer: React.FC = () => {
    const [viewModel] = useState(() => new UserViewModel());

    const { history } = useRouter();
    useEffect(() => {
        const fetchData = async () => {
            const apiResult = await viewModel.loadUsersAsync();
            if (apiResult.wasSuccessful) {
            }
        };
        let _ = fetchData();
    }, []);

    const handleRowClick = (e: any, rowData: any) => {
        history.push(`/userslist/user/${rowData.id}`);
    };

    const handleNewClick = () => {
        history.push(`/userslist/user/0`);
    };

    return useObserver(() => (
        <Container>
            <Mui.Box padding="40px 35px 40px 35px" width="100%">
                <Mui.Typography style={{ marginBottom: "20px" }} variant="h4" color="textPrimary">
                    Admin Users
                </Mui.Typography>

                {
                    <MaterialTable
                        components={{
                            Toolbar: (props) => (
                                <Mui.Box display="flex" justifyContent="space-between" alignItems="center">
                                    <StyledRoundedButton onClick={() => handleNewClick()}>Add new admin user</StyledRoundedButton>
                                    <MTableToolbar {...props} />
                                </Mui.Box>
                            ),
                        }}
                        columns={[
                            { title: "First name", field: "firstName" },
                            { title: "Surname", field: "lastName" },
                            { title: "Email", field: "emailAddress" },
                        ]}
                        options={{
                            pageSize: 50,
                            pageSizeOptions: [10, 20, 50, 100],
                            emptyRowsWhenPaging: false,
                        }}
                        data={viewModel.getAdminUsers}
                        onRowClick={handleRowClick}
                        title=""
                    />
                }
            </Mui.Box>
        </Container>
    ));
};
